import React from "react";
import { Header, Message } from "semantic-ui-react";

const SearchPage = () => {
  return (
    <>
      <Header as="h2">User search documentation</Header>
      <Message info>
        <Message.Header>Status</Message.Header>
        <Message.Content>
          In progress. The search documentation is not yet available.
        </Message.Content>
      </Message>
    </>
  );
};

export default SearchPage;
